module.exports = require('./dist/cleave-react.js');
